import styled from 'styled-components'

import { Badge } from '@/components/ui/badge'

export const CapitalizedBadge = styled(Badge)(() => ({
  textTransform: 'capitalize',
}))
